module.exports = __webpack_public_path__ + "static/media/bywise-icon.4e13bdc4.png";